/** "4035200041214708" → "4035 2000 4121 4708", for reading; what gets copied stays without spaces */
export function formatCardNumber(cardNumber: string): string {
  return cardNumber.replace(/\s+/g, '').replace(/(.{4})(?=.)/g, '$1 ');
}
